function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, keydownProxyEl, searchFilter, selectedCohortFilterOption, stagedPropertyFilter) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['property-values-screen'] = function({
      keydownProxyEl,
      stagedPropertyFilter,
      searchFilter
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-property-values-screen", {
          "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes({
            'display-context': $attr(`display-context`),
            'enable-enhanced-list-filters': $attr(`enable-enhanced-list-filters`),
            'event-names': $attr(`event-names`),
            'property-filter': stagedPropertyFilter.getAttributes(),
            'has-back-button': true,
            'project-id': $attr(`project-id`),
            'workspace-id': $attr(`workspace-id`),
          })),
          "on": {
            clickBack: $helpers.onPropertyFilterBackClick,
            changePropertyFilter: $helpers.onPropertyFilterChange,
            commitPropertyFilter: $helpers.onPropertyFilterCommit,
          },
          "props": {
            keydownProxyEl
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['cohort-operator-select'] = function({
      selectedCohortFilterOption
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-select", {
          "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes({
            'options': $helpers.getCohortFilterOptions(),
            'selected-option': selectedCohortFilterOption,
            'label-transform': `uppercase`,
          })),
          "on": {
            change: $helpers.onCohortFilterOptionChange
          },
          "class": {
            'mp-filter-menu-cohort-options': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-filter-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!$attr(`disable-value-selection`) && $helpers.getSelectedPropertyFilter()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['property-values-screen'].call(this, {
            keydownProxyEl,
            stagedPropertyFilter,
            searchFilter
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-properties-menu", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes({
              'all-data-groups': $attr(`all-data-groups`),
              'allow-typecast': $attr(`disable-value-selection`),
              'enable-workspace-filter-restrictions': $attr(`enable-workspace-filter-restrictions`),
              'exclude-dimension-properties': $attr(`exclude-dimension-properties`),
              'event-names': $attr(`event-names`),
              'include-custom-properties': $attr(`include-custom-properties`),
              'data-group-id': $attr(`data-group-id`),
              'open': $attr(`open`),
              'project-has-cohorts': $attr(`project-has-cohorts`),
              'hide-events': $attr(`hide-events`),
              'project-has-people': $attr(`project-has-people`),
              'project-id': $attr(`project-id`),
              'search-filter': searchFilter,
              'selected': $helpers.getMenuSelection(),
              'hide-edit-controls': $attr(`hide-edit-controls`),
              'show-all-tab': true,
              'show-special-dataset-property': $attr(`show-special-dataset-property`),
              'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
              'inline-cohorts-override': $attr(`inline-cohorts-override`),
              'cohort-operation-type': `filter`,
              'user-id': $attr(`user-id`),
              'workspace-id': $attr(`workspace-id`),
              'track-name': $attr(`track-name`),
            })),
            "hook": {
              insert: $helpers.onMenuInserted
            },
            "on": {
              deletecustomproperty: $helpers.propagateEvent,
              closedModal: $helpers.propagateEvent,
              select: $helpers.handlePropertySelect,
              selectoption: $helpers.handlePropertySelectOption,
              track: $helpers.preventTracking,
              stagedproperty: $helpers.handleStageChange,
            },
            "props": {
              context: `filter`,
              keydownProxyEl,
              tooltipPositionParentElement: $helpers.getTooltipPositionParentElement(),
              useMultipleSelection: $helpers.isCohortSelection(),
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                slot: `menu-header`
              }),
              "class": Object.assign({}, {
                'is-visible': $helpers.isCohortSelection()
              }, {
                'mp-filter-menu-header': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['cohort-operator-select'].call(this, {
                selectedCohortFilterOption
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(($helpers.isCohortSelection()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'elref': `applyButton`,
                'disabled': !$helpers.isCohortFilterValid(),
                'tabindex': 0,
              }),
              "on": {
                click: $helpers.onCohortFilterCommit
              },
              "class": {
                'mp-button-bar-primary': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Add Filter");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "selectedCohortFilterOption" in locals ? locals.selectedCohortFilterOption : typeof selectedCohortFilterOption !== "undefined" ? selectedCohortFilterOption : undefined, "stagedPropertyFilter" in locals ? locals.stagedPropertyFilter : typeof stagedPropertyFilter !== "undefined" ? stagedPropertyFilter : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;